<template>
    <el-card shadow="never" class="aui-card--fill">
        <el-row style="background-color: #F3F4F4;">
            <el-col :xs="24" :md="6" style="line-height: 40px;font-size: 16px;color: #121212;font-weight: bold;">
                <img style="width: 16px;height: 16px;margin-right: 12px;" src="../../../assets/img/user-list.png" />申报明细
            </el-col>
            <el-col :xs="24" :md="18">
                <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" style="text-align: right;">
                    <el-form-item>
                        <el-button class="uploadBtn" type="primary" @click="submitSbsj">提交申报数据</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button class="exportBtn" type="default" @click="downloadHandle">导出</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>

        <div class="mod-declare__personnel">
            <el-row style="border-bottom: 3px solid #F3F4F4;padding-bottom: 10px;">
                <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
                    
                    <el-form-item style="margin-top: 20px;margin-left: 20px;" label="申报月份">
                        <el-date-picker
                            v-model="dataForm.declareMonth"
                            type="month"
                            :clearable="false"
                            placeholder="请选择申报月份"
                            value-format="yyyy-MM">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item style="margin-top: 20px;margin-left: 20px;" label="灵活用工平台名称">
                        <el-select v-model="dataForm.bodyId" placeholder="请选择" clearable>
                            <el-option
									v-for="item in bodyPageList"
									:key="item.id"
									:label="`${item.bodyName}-${item.abbreviation}`"
									:value="item.id">
								</el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item style="margin-top: 20px;margin-left: 20px;" label="申报状态">
                        <el-select v-model="dataForm.declareStatus" placeholder="请选择" clearable>
                            <el-option label="待申报" value="0"></el-option>
                            <el-option label="申报中" value="1"></el-option>
                            <el-option label="申报成功" value="2"></el-option>
                            <el-option label="申报失败" value="3"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item style="margin-top: 20px;margin-left: 20px;" label="人员状态">
                        <el-select v-model="dataForm.personStatus" placeholder="请选择" clearable>
                            <el-option label="正常" value="0"></el-option>
                            <el-option label="异常" value="1"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item style="margin-top: 20px;margin-left: 20px;" label="灵工姓名">
                        <el-input v-model="dataForm.realName" placeholder="灵工姓名" clearable></el-input>
                    </el-form-item>
                    <el-form-item style="margin-top: 20px;margin-left: 20px;" label="申报数据编号">
                        <el-input v-model="dataForm.currentDataNo" placeholder="申报数据编号" clearable></el-input>
                    </el-form-item>
                    <el-form-item style="margin-top: 20px;margin-left: 20px;" label="唯一标识码">
                        <el-input v-model="dataForm.userUniqueCode" placeholder="申报数据编号" clearable></el-input>
                    </el-form-item>
                    <!-- <el-form-item style="margin-top: 20px;margin-left: 20px;" label="授权认证签约状态">
                        <el-select v-model="dataForm.authSignStatus" placeholder="请选择" clearable>
                            <el-option label="待签约" value="0"></el-option>
                            <el-option label="已签约" value="1"></el-option>
                            <el-option label="签约中" value="2"></el-option>
                        </el-select>
                    </el-form-item> -->
                    <el-form-item style="margin-top: 20px;margin-left: 20px;" label="申报方式">
                        <el-select v-model="dataForm.declareType" placeholder="请选择" clearable>
                            <el-option label="线上报送" value="0"></el-option>
                            <el-option label="线下报送" value="1"></el-option>
                        </el-select>
                    </el-form-item>
                    <!-- <el-form-item style="margin-top: 20px;margin-left: 20px;" label="注册电签状态">
                        <el-select v-model="dataForm.registerStatus" placeholder="请选择" clearable>
                            <el-option label="待注册" value="0"></el-option>
                            <el-option label="注册中" value="1"></el-option>
                            <el-option label="注册成功" value="2"></el-option>
                            <el-option label="注册失败" value="3"></el-option>
                        </el-select>
                    </el-form-item> -->
                    <!-- <el-form-item style="margin-top: 20px;margin-left: 20px;" label="身份证号码">
                        <el-input v-model="dataForm.idCard" placeholder="身份证号码" clearable></el-input>
                    </el-form-item> -->
                    <el-form-item style="margin-top: 20px;margin-left: 20px;">
                        <el-button type="primary" @click="getDataList()">查询</el-button>
                        <el-button type="default" @click="resetForm">重置</el-button>
                    </el-form-item>
                </el-form>
            </el-row>

            <div class="table-container">
                <el-table
                    v-loading="dataListLoading"
                    :data="dataList"
                    @selection-change="dataListSelectionChangeHandle"
                    @sort-change="dataListSortChangeHandle"
                    style="width: 100%;"
                    height="100%">
                    <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
                    <el-table-column prop="dealDetailId" label="数据编号" header-align="center" align="center" width="180"></el-table-column>
                    <el-table-column prop="currentDataNo" label="申报数据编号" header-align="center" align="center" width="180"></el-table-column>
                    <el-table-column prop="platformCompany" label="灵活用工平台名称" header-align="center" align="center" width="150"></el-table-column>
                    <el-table-column prop="realName" label="姓名" header-align="center" align="center" width="100"></el-table-column>
                    <el-table-column prop="userUniqueCode" label="用户唯一标识码" header-align="center" align="center" width="150"></el-table-column>
                    <el-table-column prop="declareMonth" label="申报月份" header-align="center" align="center" width="120"></el-table-column>
                    <el-table-column prop="personStatus" label="人员状态" header-align="center" align="center" width="100">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.personStatus === 0" size="small" type="success">正常</el-tag>
                            <el-tag v-else-if="scope.row.personStatus === 1" size="small" type="danger">异常</el-tag>
                            <el-tag v-else size="small">--</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="declareStatus" label="申报状态" header-align="center" align="center" width="100">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.declareStatus === 0" size="small" type="info">待申报</el-tag>
                            <el-tag v-else-if="scope.row.declareStatus === 1" size="small" type="warning">申报中</el-tag>
                            <el-tag v-else-if="scope.row.declareStatus === 2" size="small" type="success">申报成功</el-tag>
                            <el-tag v-else-if="scope.row.declareStatus === 3" size="small" type="danger">申报失败</el-tag>
                            <el-tag v-else size="small">--</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="declareType" label="申报方式" header-align="center" align="center" width="100">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.declareType === 0" size="small" type="primary">线上申报</el-tag>
                            <el-tag v-else-if="scope.row.declareType === 1" size="small" type="warning">线下申报</el-tag>
                            <el-tag v-else size="small">--</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="income" label="收入（含税）" header-align="center" align="center" width="120">
                        <template slot-scope="scope">
                            {{ scope.row.income ? moneyUtils(scope.row.income) : '--' }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="taxAmount" label="税金金额（元）" header-align="center" align="center" width="120">
                        <template slot-scope="scope">
                            {{ scope.row.taxAmount ? moneyUtils(scope.row.taxAmount) : '--' }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="incomeTax" label="个税（元）" header-align="center" align="center" width="120">
                        <template slot-scope="scope">
                            {{ scope.row.incomeTax ? moneyUtils(scope.row.incomeTax) : '--' }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="valueAddedTax" label="增值税（元）" header-align="center" align="center" width="120">
                        <template slot-scope="scope">
                            {{ scope.row.valueAddedTax ? moneyUtils(scope.row.valueAddedTax) : '--' }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="surcharge" label="附加税（元）" header-align="center" align="center" width="120">
                        <template slot-scope="scope">
                            {{ scope.row.surcharge ? moneyUtils(scope.row.surcharge) : '--' }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="commissionTotal" label="佣金/服务费合计（元）" header-align="center" align="center" width="150">
                        <template slot-scope="scope">
                            {{ scope.row.commissionTotal ? moneyUtils(scope.row.commissionTotal) : '--' }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="remark" label="备注" header-align="center" align="center" show-overflow-tooltip></el-table-column>
                </el-table>
            </div>

            <el-pagination
                background
                :current-page="page"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="limit"
                :total="total"
                layout="total, sizes, prev, pager, next, jumper"
                @size-change="pageSizeChangeHandle"
                @current-change="pageCurrentChangeHandle">
            </el-pagination>
        </div>

        <el-dialog title="选择税源地" :visible.sync="submitDialogVisible" width="600px" :before-close="handleCloseSubmitDialog">
            <div class="upload-dialog-content">
                <el-form>
                    <el-form-item label="税源地名称:">
                        <el-select v-model="bodyId" placeholder="请选择税源地" :clearable="false" style="width: 60%;">
                            <el-option
                                v-for="item in bodyPageList"
                                :key="item.id"
                                :label="`${item.bodyName}-${item.abbreviation}`"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleCloseSubmitDialog">取 消</el-button>
                <el-button type="primary" @click="confirmSubmit">确 定</el-button>
            </span>
        </el-dialog>
    </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import DataUtils from '@/utils/DataUtils'
import DateUtils from '@/utils/DateUtils'
import { addDynamicRoute } from '@/router'
import Cookies from 'js-cookie'
import qs from 'qs'

export default {
  mixins: [mixinViewModule],
  data () {
    return {
      submitDialogVisible: false,
      fileList: [],
      bodyId: '',
      mixinViewModuleOptions: {
        isBodyPage: true,
        createdIsNeed: true,
        getDataListURL: '/sys/plat/tax/declare/detail/page',
        getDataListIsPage: true,
        exportURL: '/declare/personnel/export'
      },
      dataForm: {
        declareMonth: DateUtils.format(new Date(), 'yyyy-MM'),
        bodyId:'',
        declareStatus:'',
        personStatus:'',
        realName:'',
        currentDataNo:'',
        userUniqueCode:'',
        authSignStatus:'',
        declareType:'',
      }
    }
  },
  methods: {
    moneyUtils(data){
		return DataUtils.moneyUtils(data)
	},
    resetForm () {
      this.dataForm = {
        declareMonth: DateUtils.format(new Date(), 'yyyy-MM'),
        bodyId:'',
        declareStatus:'',
        personStatus:'',
        realName:'',
        currentDataNo:'',
        userUniqueCode:'',
        authSignStatus:'',
        declareType:'',
      }
      this.getDataList()
    },
    submitSbsj () {
      this.submitDialogVisible = true
      this.fileList = []
    },
    handleCloseSubmitDialog () {
      this.submitDialogVisible = false
      this.fileList = []
    },
    downloadTemplate () {
      const token = Cookies.get('access_token')
      window.open(`${window.SITE_CONFIG['apiURL']}/sys/plat/tax/person/submit/template?access_token=${token}`)
    },
    confirmSubmit () {
      if (!this.bodyId) {
        return this.$message.warning('请选择税源地')
      }
      this.$http.post('/sys/plat/tax/declare/detail/submit', {
        bodyId: this.bodyId,
        declareMonth: this.dataForm.declareMonth
      }).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.$message.success('提交成功')
        this.submitDialogVisible = false
        this.getDataList()
      }).catch(() => {
        this.$message.error('提交失败')
      })
    },
    downloadHandle () {
      const params = qs.stringify({
        'access_token': Cookies.get('access_token'),
        ...this.dataForm
      })
      window.open(`${window.SITE_CONFIG['apiURL']}/sys/plat/tax/declare/detail/export?${params}`)
    },
    // resubmitHandle () {
    //   if (this.dataListSelections.length === 0) {
    //     return this.$message.warning('请选择需要重新报送的数据')
    //   }
    //   this.$confirm('确认要重新报送选中的数据吗？', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   }).then(() => {
    //     this.$http.post('/declare/personnel/resubmit', {
    //       ids: this.dataListSelections.map(item => item.id)
    //     }).then(({ data: res }) => {
    //       if (res.code !== 0) {
    //         return this.$message.error(res.msg)
    //       }
    //       this.$message.success('重新报送成功')
    //       this.getDataList()
    //     }).catch(() => {})
    //   }).catch(() => {})
    // },
  //   viewHandle (id) {
  //     localStorage.setItem(this.$route.name, JSON.stringify(this.dataForm))
  //     const routeParams = {
  //       routeName: `${this.$route.name}__查看详情`,
  //       title: '人员报送详情',
  //       path: 'declare/personnel-detail',
  //       params: {
  //         id: id
  //       }
  //     }
  //     addDynamicRoute(routeParams, this.$router)
  //   },
  //   editHandle (id) {
  //     localStorage.setItem(this.$route.name, JSON.stringify(this.dataForm))
  //     const routeParams = {
  //       routeName: `${this.$route.name}__编辑`,
  //       title: '编辑人员报送',
  //       path: 'declare/personnel-edit',
  //       params: {
  //         id: id
  //       }
  //     }
  //     addDynamicRoute(routeParams, this.$router)
  //   }
  }
}
</script>

<style lang="scss" scoped>
.mod-declare__personnel {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 190px);
  
  .el-row {
    flex-shrink: 0;
  }
  
  .table-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    margin-top: 20px;

    .el-table {
      flex: 1;
      overflow: hidden;
    }
  }
  
  .el-pagination {
    flex-shrink: 0;
    margin-top: 20px;
    text-align: right;
  }
}

/deep/ .el-table {
  .el-table__header-wrapper {
    position: sticky;
    top: 0;
    z-index: 10;
    background-color: #f5f7fa;
  }

  .el-table__fixed-header-wrapper {
    position: sticky;
    top: 0;
    z-index: 10;
    background-color: #f5f7fa;
  }
}
</style>